import { render, staticRenderFns } from "./InceptionAssessmentAiWrapper.vue?vue&type=template&id=654c14b8&scoped=true"
import script from "./InceptionAssessmentAiWrapper.vue?vue&type=script&lang=ts"
export * from "./InceptionAssessmentAiWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c14b8",
  null
  
)

export default component.exports